<template>
  <div>
    <div>
      Bitte {{ duzen('gebe', 'geben Sie') }} den 6-stelligen Code aus der Authenticator-App ein
    </div>
    <div class="flex flex-row justify-center gap-2 mt-1.5">
      <ElInput
        v-model="form.code"
        v-maska="'######'"
        style="width: 95px"
      />
      <AppButton
        type="primary"
        :handler="submit"
      >
        Bestätigen
      </AppButton>
    </div>

    <FieldError
      v-for="error in errors?.code"
      :key="error"
    >
      {{ error }}
    </FieldError>
  </div>
</template>

<script setup lang="ts">
import FieldError from '@/application/components/ui/FieldError.vue';
import AppButton from '@/application/components/ui/AppButton.vue';
import { ElInput } from 'element-plus';
import { vMaska } from 'maska/vue';

import { confirmTwoFactorAuthentication } from "@/api/auth/authApi";
import { useForm } from "@/api/lib/integration";
import { useBaseDataStore } from '@/user/store/baseDataStore.ts';

const emit = defineEmits(['confirmed']);

const { duzen } = useBaseDataStore();

const { submit, form, errors } = useForm(
  confirmTwoFactorAuthentication,
  { code: '' },
  () => emit('confirmed'),
);
</script>
